import transformImage from './transform-image';

const transformOfferedItem = ({ name, description = '', image } = {}) => ({
    name,
    description,
    image: transformImage(image),
});

export default transformOfferedItem;
